module.exports = __webpack_public_path__ + "static/media/Circle.63ea7a16.svg";